import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The 2000 B.C.E preloader flights, as SDK scene data — a tour with no flyover:
 * the exit parks the camera on `previewTourEnd`, and that is the rest pose.
 *
 * Converted once from the legacy `kaaba2000BceSceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 *
 * The turntable rides 1 cm above the scene cage's roof, which is why the
 * preloader lifts collisions for its routes (`createSdkScene.ts`).
 */
export const KAABA_2000BCE_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [-6.92, 3.75, 3.85],
        lookAt: [-1.05, 0.35, -0.81],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 8.229975699,
          azimuth: 2.653862047,
          polar: 1.144914564,
        },
        target: [-1.05, 0.35, -0.81],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 8.229975699,
          azimuth: 4.224658373,
          polar: 1.144914564,
        },
        target: [-1.05, 0.35, -0.81],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 8.229975699,
          azimuth: 5.7954547,
          polar: 1.144914564,
        },
        target: [-1.05, 0.35, -0.81],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 8.229975699,
          azimuth: 7.366251027,
          polar: 1.144914564,
        },
        target: [-1.05, 0.35, -0.81],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 8.229975699,
          azimuth: 8.937047354,
          polar: 1.144914564,
        },
        target: [-1.05, 0.35, -0.81],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [4.15, 1.81, 4.08],
        lookAt: [-1.05, 0.35, -0.81],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
];
